import React from 'react';
import ReactDOM from 'react-dom';
import './style/index.css';
import App from './App';
import * as firebase from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyCq8oMpuxX0TSvj7Uk8if52EhzBkXUUGoo",
    authDomain: "jahnesgmbhwebapp.firebaseapp.com",
    databaseURL: "https://jahnesgmbhwebapp.firebaseio.com",
    projectId: "jahnesgmbhwebapp",
    storageBucket: "jahnesgmbhwebapp.appspot.com",
    messagingSenderId: "1059311293238",
    appId: "1:1059311293238:web:523fe34c1834d02b"
};

firebase.initializeApp(firebaseConfig);

ReactDOM.render(<App />, document.getElementById('root'));

